import { IRoomValidationStatusCode } from "@backend/src/shared/schemas/schemas";

export const BLUE_GRADIENTS: Record<string, string> = {
  VERY_LIGHT: "#E0FFFF",
  LIGHT: "#00FFFF",
  MEDIUM: "#0080FF",
  DARK: "#0000FF",
  VERY_DARK: "#00008B",
};

export const DESIGN_DEVIATION_STATUS_COLORS: Record<
  "01" | "02" | "03" | "04" | "05",
  string
> = {
  "01": "#845EF7",
  "02": "#12B886",
  "03": "#FF922B",
  "04": "#F06595",
  "05": "#FFD43B",
} as const;

export const YELLOW_GRADIENTS: Record<string, string> = {
  VERY_LIGHT: "#FFFFE0",
  LIGHT: "#FFFF00",
  MEDIUM: "#FFD700",
  DARK: "#FFA500",
  VERY_DARK: "#FF8C00",
};

export const MMI_COLORS: Record<number, string> = {
  0: "#D73296",
  100: "#BE2823",
  125: "#D24B46",
  150: "#E17873",
  175: "#F0AAAA",
  200: "#E69637",
  225: "#EBAF64",
  250: "#F0C88C",
  275: "#F5E6D7",
  300: "#FAF050",
  325: "#D7CD41",
  350: "#B9AF3C",
  375: "#9B9632",
  400: "#378246",
  425: "#4BAA5A",
  450: "#64C37D",
  475: "#9BD7A5",
  500: "#1F46AF",
  600: "#9B00CD",
} as const;

export const DR_STATUS_COLORS: Record<string, string> = {
  "": "#CED4DA",
  "–": "#CED4DA",
  dR0: "#7B0F14",
  dR1: "#E03131",
  dR2: "#F76707",
  dR3: "#FCC419",
  dR3A: "#8f772e",
  dR4: "#2F9E44",
} as const;

export const GRAY = "#d6d6d6";

export const ROOM_VALIDATION_STATUS_COLORS: Record<IRoomValidationStatusCode, string> = {
  APPROVED: "#1B7F3A",
  APPROVED_WITH_DEVIATIONS: "#FFA94D",
  NEEDS_CHECK: "#FF3B30",
};

export const PERCENT_COLORS = Object.freeze({
  ZERO: "#FF3B30",
  P01_20: "#FF6B6B",
  P21_40: "#FFA94D",
  P41_60: "#FFD43B",
  P61_80: "#F3F82C",
  P81_99: "#1B7F3A",
  FULL: "#5cdc85",
});
